import React from "react";
import { AdvancedDragModal, ADModalBody, ADModalFooter } from "src/componentsUtils/AdvancedDragModal";
import { GlassButton } from "./GlassButtons";
import { ViewButtonCheck } from "src/propertyInfoTemplates/PropertyComponents";
import { GlassBox } from "src/propertyInfoTemplates/PropertyComponents";
import { useWindowContext } from "src/WindowManager/useWindowContext";
import { closeWindow, ManagedWindow } from "src/WindowManager/WindowState";
import { Localization } from "@viamap/viamap2-common";
import { PendingConflict } from "./ConflictSearchDialog";



export default function ConflictSearchResults({ window }: { window: ManagedWindow }) {
   const results: PendingConflict[] = window.windowParams?.results || [];
   const { dispatch: windowDispatch } = useWindowContext();
   const [onlyShowMatching, setOnlyShowMatching] = React.useState<boolean>(false);

   const getMatches = (r: PendingConflict) => r?.matchedCount
   const filteredResults = onlyShowMatching ? results.filter(r => getMatches(r) > 0 || r.err) : results;
   const hasAnyMatches = filteredResults.some((r) => getMatches(r) > 0);

   return (
      <AdvancedDragModal
         PosDefault={{ left: "460px", top: "80px", width: "640px", height: "520px" }}
         title={Localization.getText("Conflict search results")}
         onClose={() => windowDispatch(closeWindow(window.id))}
      >
         <ADModalBody>
            <GlassBox title={Localization.getText("Click a layer to preview conflicts on the map")}>
               <div style={{ width: '100%', height: '100%', overflow: 'auto' }}>
                  <table className="Table-MitProp Table-MitProp--unifiedRows">
                     <thead>
                        <tr>
                           <th>{Localization.getText("Source")}</th>
                           <th>{Localization.getText("Layer")}</th>
                           <th style={{ textAlign: 'right' }}>{Localization.getText("Matches")}</th>
                        </tr>
                     </thead>
                     <tbody>
                        {filteredResults.map((r: PendingConflict, idx: number) => {
                           const source = r.source || "Unknown source";
                           const layer = r.layerName || "Unnamed layer";
                           const matches = r.matchedCount
                           return (
                              <tr
                                 key={idx}
                                 style={{ cursor: window.windowParams?.onSelect ? 'pointer' : 'default' }}
                                 onClick={() => window.windowParams?.onSelect?.(r)}
                              >
                                 <td style={{ wordBreak: 'break-word', whiteSpace: 'normal' }}>{source}</td>
                                 <td style={{ wordBreak: 'break-word', whiteSpace: 'normal' }} title={layer}>{r.title ?? layer}</td>
                                 {
                                    r.err ?
                                       <td style={{ color: "red", fontWeight: 'bold' }}>{Localization.getText("Error")}</td>
                                       :
                                       <td style={{ textAlign: 'right' }}>{matches}</td>
                                 }
                              </tr>
                           );
                        })}
                     </tbody>
                  </table>
               </div>
            </GlassBox>
         </ADModalBody>

         <ADModalFooter>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
               <ViewButtonCheck checked={onlyShowMatching} onCheck={(e, v) => setOnlyShowMatching(!v)}>
                  {Localization.getText("Only show matching layers")}
               </ViewButtonCheck>
               <div style={{ display: 'flex', gap: 8 }}>
                  <GlassButton
                     disabled={!hasAnyMatches}
                     onClick={async () => {
                        try {
                           await window.windowParams?.onAdd?.(results);
                        } catch (e) {
                           console.error(e);
                        }
                     }}
                  >
                     {Localization.getText("Add as layer")}
                  </GlassButton>
                  <GlassButton onClick={async () => {
                     windowDispatch(closeWindow(window.id))
                  }}>
                     {Localization.getText("Close")}
                  </GlassButton>
               </div>
            </div>
         </ADModalFooter>
      </AdvancedDragModal>
   );
}